/**
 * Converts a JSON key into a human-readable title
 * @param key The JSON key to convert (e.g. 'foo', 'fooBar')
 * @returns A human-readable title (e.g. 'Foo', 'Foo Bar')
 */
export const PrettyKey = (key: string): string => {
  // Handle empty or null input
  if (!key) return '';

  // Split by camelCase and uppercase first letter of each word
  return key
    // Insert space before capital letters
    .replace(/([A-Z])/g, ' $1')
    // Trim any leading/trailing spaces
    .trim()
    // Capitalize first letter of each word
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
